<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12">
						<h2 class="mb-4 pb-2 pt-2 d-flex align-items-start">
							<span>HHA: {{ provider_data.first_name }} {{ provider_data.last_name }}

								<!-- <br/><small class="font-italic">ssn: {{ provider_data.ssn }}</small> -->

							</span>

						</h2>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
			<div class="col-12 col-xl-12">
				<form @submit.prevent="onSubmit">
					<div class="mb-2">
						<div class="row">
							<div class="col">
								<label class="mb-2 h6 green">1. PERSONAL INFO</label>
							</div>
							<div class="col">
								<div class="text-right">
									<div class="trigger-hidden-content ml-1 d-inline-block">
									<!-- New Actions section for password reset section -->
									<span class="text-right button">
										Actions <i class="fa fa-caret-down" aria-hidden="true" style="vertical-align: baseline"></i>
									</span>
									<div class="hidden-content hc-right-bottom">
										<div>
											<ul class="list-unstyled text-left">
												<template>
													<li :class="{'input-disabled':provider_data.sign_up == 1}" class="pb-2 pt-2 d-flex align-items-center
														cursor-pointer" @click="openBulkModal('sign_up_sso')"
													>
													<i class="fa fa-sign-in fa-ninja fa-ninja-black" aria-hidden="true" style="vertical-align: baseline"></i>
															<small class="ml-1">User SignUp</small>

													</li>
													<li  :class="{'input-disabled':provider_data.sign_up == 0}"  class="pb-2 pt-2 d-flex align-items-center
														cursor-pointer" @click="loginSSO"
													>
													<i class="fa fa-sign-in fa-ninja fa-ninja-black" aria-hidden="true" style="vertical-align: baseline"></i>
															<small class="ml-1">User Login</small>

													</li>
													<!-- New Password Dropdown -->
													<password-action :user_role="user_role" :checked_user="1" :sign_up="provider_data.sign_up"></password-action>

											</template>
											</ul>
										</div>
									</div>
							</div>
                <hub-spot-ticket
                  :provider_name="provider_data.first_name"
                  :provider_last_name="provider_data.last_name"
                  :provider_country_code="provider_data.country_code"
                  :provider_phone="provider_data.phone"
                  :provider_email="provider_data.email"
                  ></hub-spot-ticket>
									<button type="button" class="button" @click="showHistory">Employee history</button>
								</div>
							</div>
						</div>
					</div>

					<div class="lightgray-content p-3 rounded mb-2">
						<div class="row">
							<div class="col-12 col-lg-4  col-xl-3">
								<div class="form-group input-content">
									<label>IMAGE</label>
									<div class="thumb-container circle-thumb profile-thumb" :style="{ 'background-image' : 'url(data:image/jpeg;base64,'+provider_data.image+')' }"></div>
									<!-- <p class="text-center"><a class="button" href="#">Change image</a></p> -->
								</div>
							</div><!--col-->
							<div class="col-12 col-lg-4">
								<div class="form-group input-content">
									<label>Email</label>
									<div class="flex">
										<input placeholder="Email" type="text" v-model="provider_data.email" class="form-control" v-validate="'email'" name="email" :disabled="provider_data.email == null || (user_role === 'csm')">
										<img  @click="openBulkModal('sign_up_sso')" width="20" src="../../../assets/images/icons/solid/pencil-alt-green.svg"
										class="m-1 cursor-pointer"/>
									</div>
									<span class="input-error-msg">{{ errors.first('email') }}</span>
								</div>
								<div class="form-group input-content">
									<label>First name</label>
									<input placeholder="First name" type="text" v-model="provider_data.first_name" class="form-control" v-validate="'required'" name="first_name">
									<span class="input-error-msg">{{ errors.first('first_name') }}</span>
								</div>
								<div class="form-group input-content">
									<label>Last name</label>
									<input placeholder="Last name" type="text" v-model="provider_data.last_name" class="form-control" v-validate="'required'" name="last_name">
									<span class="input-error-msg">{{ errors.first('last_name') }}</span>
								</div>
								<!-- <div class="form-group input-content">
									<label>Gender</label>
									<v-select class="mb-2"  :searchable="false"  v-model="provider_data.gender"
										:options="[{ 'value' : '-', 'label' : '-'}, { 'value' : 'Male', 'label' : 'Male' }, { 'value' : 'Female', 'label' : 'Female' }]">
									</v-select>
								</div> -->
							</div><!--col-->
							<div class="col-12 col-lg-4">
								<!-- <div class="form-group input-content">
									<label>Birthday</label>
										<div class="row ml-0">
												<date-picker placeholder="Birthday" class="date_picker_new" v-model="provider_data.dob" :range="false" :format="'MM-DD-YYYY'"
												:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
												:valueType="'YYYY-MM-DD'">
												</date-picker>
										</div>
									<span class="input-error-msg">{{ errors.first('dob') }}</span>
								</div> -->

								<div class="form-group input-content">

									<div class="row">
										<div class="col-5">
											<phone-country-code
												:rule="'not_required'"
											    :section="'existin-provider'"
												:country_codes="country_codes"
												:form="provider_data"
												@countryInput="countryInput"/>

											<span class="input-error-msg">{{ errors.first('country_code') }}</span>
										</div>
										<div class="col-7">
											<label>Mobile number</label>
											<input placeholder="Mobile number" type="text" v-model="provider_data.phone" class="form-control" name="phone"
												v-validate="'min:8|max:10'" >
											<span class="input-error-msg">{{ errors.first('phone') }}</span>
										</div>
									</div>
								</div>
								<div class="form-group input-content">
									<label>Preferred language</label>
									<multiselect v-model="provider_data.language"
									label="value"
									:options="preferred_languages"></multiselect>
								</div>

								<!--
								<div class="form-group input-content">
									<label>SSN</label>
									<input disabled  placeholder="SSN" type="text" v-model="provider_data.ssn" class="form-control cursive font-italic" v-validate="" name="ssn">
									<span class="input-error-msg">{{ errors.first('ssn') }}</span>
								</div>
							-->
							</div><!--col-->
						</div><!--row-->

						<!--
						<div class="row">
							<div class="col">
								<label class="mb-2 h6 green">TAGS</label>
								<tags :entity_str="'App\\Models\\Provider'"
									:entity="provider_data" ref="tags"></tags>
							</div>
						</div>
						-->
					</div>

					<div class="row">
						<div class="col-md-12">
							<div class="text-right mt-2 mb-5">
								<!-- //change router link to current user + router -->
								<router-link :to="{ name : user_role+'.providers.index' }" tag="button" class="button gray-content large-button">Back</router-link>

								<button type="submit" class="button large-button">Update</button>
							</div>
						</div>
					</div>
				</form>



				<label class="mb-2 h6 green">3. AGENCIES</label>

				<div class="row">
					<div class="col-4">
						<multiselect :options="organizations" :show-labels="true" v-model="selected_organization" label="label" @select="message_selected_organization = ''"></multiselect>
						<span v-if="message_selected_organization != ''" style="color: #b76b72">{{ message_selected_organization }}</span>
					</div>
					<div class="col-8">
						<a class="button green-content large-button white" @click="addOrganization">
							<img src="../../../assets/images/icons/solid/plus_white.svg" width="8" class="mr-1" />
							<span>Add agency</span>
						</a>
					</div>
				</div>


				<div :key="organization.id" v-for="(organization, index) in provider_organizations">



					<provider-organization
          :provider="provider_data" :organization="organization"
					:key="componentKey"
					:organization_index="index" :show_organization_details="true"
					:country_codes="country_codes"
					>

						<template slot="header" slot-scope="props" >
							<!--<multiselect v-model="" :options=""></multiselect>-->
							<div class="row">
								<div class="col" >
									<div class="form-group input-content d-flex align-items-center" >
										<div :class="{'current-agency' : agency_id == organization.id }" class="count-number count-number-large mr-2">{{ index+1 }}</div>
										<router-link tag="a" target="_blank" :to="{name:'csm.providers.info', params:{ agency_id: organization.id} } " class="mx-btn">
										<label class="h5 cursor-pointer mb-0">{{ organization.name }}</label>
										</router-link>


									</div>
								</div><!--col-->
								<!-- <div class="col"> -->
									<!-- <div class="text-right"> -->
                    <div class="status_container margin-status-50">
	                      <provider-status-action
                          :key="organization.id"
                          :user_status="props.slot_provider.provider_status_id"
                          :provider="props.slot_provider"
                          @updateStatusProvider="updateStatusProvider"
                        />
                      </div>

										<!-- <toggle-button v-model="organization.is_active ? true : false"
												:labels="{ checked : 'Active', unchecked : 'Deactivated'}" :width="100"
												:color="{ checked : green, unchecked : red, disabled : '#CCCCCC' }" :sync="true"
												@change="toggleOrganizationStatus(organization)"
											/> -->
									<!-- </div> -->
								<!-- </div> -->
							</div><!--row-->
						</template>

					</provider-organization>
				</div>



			</div><!--col-->
		</div><!--row-->

		<!-- provider history -->
		<b-modal v-model="show_history" title="Employee history"  ok-only ok-title="Close" size="lg">
			<table-view :table_headers="['Date','Text', 'By']" :dataOptions="['time','text','by']" v-if="show_history" :history="history"></table-view>
		</b-modal>

		<password-reset
		:bulk_modals="bulk_modals"
		@updateProviderSignUp="updateProviderSignUp"
		@closeBulkModal="closeBulkModal"
		@updateProviderEmail="updateProviderEmail"
		@getProvider="getProvider"
		:bulk_selection="bulk_selection">
		</password-reset>
	</div>
</template>

<script>
import PasswordDropdown from '../../shared/PasswordDropdown.vue';

import PhoneCountryCode from '../../shared/inputs/PhoneCountryCode';
import ProviderStatusAction from '../../shared/inputs/ProviderStatusAction.vue';
import ProvidersMixin from '../../shared/ProvidersMixin'
import HubSpotTicket from '../../shared/inputs/HubSpotTicket'
import { EventBus } from './../../../event_bus.js';

export default {
	components : {
		'password-reset': PasswordDropdown,
		PhoneCountryCode,ProviderStatusAction,
    HubSpotTicket
	},
  mixins:[ProvidersMixin],
	computed : {
		// subrole_length: function(){
		// 	return this.subrole_config.length
		// },
		provider_organization_length:  function(){
			return this.provider_organizations.length
		}
	},
	data : function(){
		return {
			componentKey:0,
			id : this.$route.params.id,
			agency_id:null,
			provider_data : {
				ssn : '',
				first_name : '',
				last_name : '',
				// dob: '',
				email : '',
				// gender: '',
				language: {},
				phone: '',
				country_code : '',
				is_suspended : false,
				is_applicant: 1
			},
			show_organizations : false,
			organizations : [],
			provider_organizations : [],
			preferred_languages : [],
			selected_organization : { },
			message_selected_organization : '',
			country_codes : [],
			history : [],
			per_page_history : 5,
			current_page_history : 1,
			show_history : false,
			red : this.config.COLORS.RED,
			green : this.config.COLORS.GREEN,
			user_role:'',
			bulk_modals:{
				show_reset_password_email:false,
				show_reset_password_plain:false,
				show_reset_password_text:false,
				show_send_sms:false,
				show_sign_up_sso:false,
			},
			bulk_selection:[],
			subrole_config:[],
			add_new_agency:true,
			sso_agency_id_holder: null,
      itemProp:''
		}
	},
	watch: {
		'provider_data.phone': function(val){
			if(val != '' || val != null){
				var removedText = val.replace(/\D+/g, '');
				this.provider_data.phone = removedText
			}
		}
	},
	created : function(){
		this.user_role = this.$store.getters.getRole
		this.agency_id =this.$route.query.agency_id
		this.getCountries();
		this.getProvider();
		this.getOrganizations();
		this.getHistory();
	},

	methods : {
		updateProviderSignUp(){
			this.provider_data.sign_up = 1
		},
		getFirstAgencyID(){
			if(this.provider_organizations && this.provider_organizations.length > 0){
				this.sso_agency_id_holder = this.provider_organizations[0].id
			}
		},
		countryInput: function(val){
				this.provider_data.country_code = val
		},
		getCountries : function(){
			this.$store.dispatch('getCountries', {}).then((res) => {

				this.country_codes = res.data.data;
			}).catch((error) =>{
				console.log(error);
			});
		},
		getProvider : function(){
			var params = {
				id : this.id
			}

			this.$store.dispatch('getProvider', params).then((res) => {
				this.provider_data = res.data.data;
				this.getPreferredLanguages();
				this.getProviderOrganizations();
        EventBus.$emit('getInfo')
			}).catch((error) => {
				console.log(error);
			});

		},
		getOrganizations : function() {
			var params = {
				filters : {
					page : this.current_page,
					per_page : this.per_page,
					search: this.search,
					page_loading: false,
					to_select : true
				}
			}

			this.$store.dispatch('getOrganizations', params).then((res) => {
				this.organizations = res.data.data;
			}).catch((error) => {
				console.log(error);
			});
		},
		checkNewAgency: function(){
			if(this.add_new_agency == true){
				this.selected_organization.value = this.agency_id
				this.addOrganization()
			}
		},
		getProviderOrganizations : function() {
			//this is new function to add provider to organization if it is newly added or created
			var params = {
				id : this.id,
				filters : {

				}
			}

			this.$store.dispatch('getProviderOrganizations', params).then((res) => {
				this.provider_organizations = res.data.data;
				// check all agencies. if ageny_id is not in DB, we add it manually here
				if(this.agency_id != null || this.agency_id != undefined){
					if(this.provider_organizations.length>=1 && this.agency_id != null){
						for(let org in this.provider_organizations){
							if(this.provider_organizations[org].id == this.agency_id )
								this.add_new_agency = false
						}
					}
					this.checkNewAgency();
				}else{
					this.getFirstAgencyID()
				}

				this.getSubrolesConfig();

			}).catch((error) => {
				console.log(error);
			});


		},
		getSubrolesConfig : function(){
			return
			this.subrole_config = []
			for(let i in this.provider_organizations){
				var params = {
					id : this.provider_organizations[i].id
				}
				this.$store.dispatch('getConfigOrganizationSubrole', params).then((res) => {
					this.subrole_config.push(res.data)
				}).catch((error) => {
					console.log(error);
				});

			}
			this.$forceUpdate();

		 },
		onSubmit : function(){
			this.$validator.validateAll().then((result) => {
				if(result){

					// if(this.provider_data.gender.value)
					// 	this.provider_data.gender = this.provider_data.gender.value;

					if(this.provider_data.groups)
						this.provider_data.groups = this.$refs.tags.groups;

					if(typeof this.provider_data.country_code == 'object'){
						this.provider_data.country_code = this.provider_data.country_code.value;
					}


					if(this.provider_data.language != null){
						this.provider_data.language = this.provider_data.language.key
					}

					this.$store.dispatch('editProvider', this.provider_data).then((res) => {
						this.getPreferredLanguages();
					}).catch((error) => {
						console.log(error);
					});
				}
			});
		},
		getPreferredLanguages : function(){
			this.preferred_languages = []
			var params = { filters:{available_for_users: 1} };
			this.$store.dispatch('getLanguages', params).then((res) => {
				for(let i in res.data.data){
					if(this.provider_data.language == res.data.data[i][0].code_2){
						this.provider_data.language = {key:res.data.data[i][0].code_2, value:res.data.data[i][0].name}
					}
					this.preferred_languages.push({key:res.data.data[i][0].code_2, value:res.data.data[i][0].name})
				}
			}).catch((error) => {
				console.log(error);
			});
		},

		addOrganization : function(){

			this.message_selected_organization = '';
			if(this.selected_organization && this.selected_organization.value){
				var params = {
					organization_id : this.selected_organization.value,
					provider_id : this.id,
					create : false,
				}

				this.$store.dispatch('addProviderToOrganization', params).then((res) => {
					this.getProviderOrganizations();

					this.selected_organization = null;
				}).catch((error) => {
					console.log(error);
				});
			}else{
				this.message_selected_organization = 'Please, select an agency';
			}
			this.getSubrolesConfig()
		},


		getHistory : function(){


		},

		showHistory : function(){

			var params = {
				id : this.id
			}

			this.$store.dispatch('getProviderHistory', params).then((res) => {
				this.history = res.data.data;
			}).catch((error) => {
				console.log(error);
			})

			this.show_history = true;
		},

		// toggleOrganizationStatus : function(status, organization){

		// 	var method = '';

		// 	if(organization.is_active){

		// 		//deactivate provider

		// 		method = 'deleteProviderFromOrganization';
		// 	}else{
		// 		//activate provider

		// 		method = 'addProviderToOrganization';
		// 	}

		// 	var params = {
		// 		organization_id : organization.id,
		// 		provider_id : this.id
		// 	}

		// 	this.show_organizations = false;
		// 	this.$store.dispatch(method, params).then((res) => {
		// 		organization.is_active = !organization.is_active;
		// 		this.componentKey += 1;
		// 		this.show_organizations = true;

		// 	}).catch((error) => {
		// 		console.log(error);
		// 	});

		// },
		openBulkModal: function(name){
			this.bulk_selection = []
			this.bulk_selection.push({
				id: this.id,
				first_name: this.provider_data.first_name,
				last_name: this.provider_data.last_name,
				email: this.provider_data.email
			})
			this.bulk_modals['show_' + name] = true;
		},
		closeBulkModal: function(name){
			this.bulk_modals['show_' + name] = false;
		},
		updateProviderEmail: function(email){
			this.provider_data.email = email
		},
		loginSSO: function (){
			var params = {
					agency_id : this.agency_id || this.sso_agency_id_holder,
					user_id : this.id
				}
				this.$store.dispatch('loginAsProviderSSO',params).then((res)=>{
					console.log(res.data)
					if(res.data.url){
						window.open(res.data.url, '_blank');
					}

				}).catch((error) => {
					console.log(error);
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/admin/providers/AdminProviderDetailComponent.vue